import { IMetadata } from "@/utils/seo";
import { Section } from "./home";

export interface GenericContact {
    calendlyUri: string;
    whatsapp: string;
    telegram: string;
    whatsappPrefix: string;
    title: string;
    subtitle: string;
    calendlyTitle?: string; // Testo personalizzato per il pulsante Calendly
    whatsappTitle?: string; // Testo personalizzato per il link WhatsApp
}

export interface ContactsInfo {
    id: string;
    title: string;
    description: string;
    email: string;
    number: string;
    phoneTitle?: string;
    emailTitle?: string;
    contacts: GenericContact;
}

export interface IContactData {
    headImage: string;
    address: string;
    bookEmail: string;
    bookPhone: string;
    cap: string;
    city: string;
    countryCode: string;
    createdAt: string;
    feedbackEmail: string;
    feedbackPhone: string;
    infoEmail: string;
    infoPhone: string;
    infoPhoneTitle?: string;
    infoEmailTitle?: string;
    piva: string;
    streetNumber: string;
    updatedAt: string;
    bookingContacts: GenericContact;
    feedbackContacts: GenericContact;
    helpContacts: GenericContact;
    wordings: Section;
    contactUs: Section;
    metadata?: IMetadata;
}

export enum TypeContact {
    Whatsapp = "Whatsapp",
    Telegram = "Telegram",
}
